import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Package, ArrowLeft, Key, Tag, ShoppingBag, Home, Wrench, Database } from 'lucide-react';
import { Button } from '../../components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('admin_logged_in');
    if (!isLoggedIn) {
      navigate('/admin/login');
      return;
    }

    // Check maintenance status
    const checkMaintenance = async () => {
      try {
        const response = await axios.get(`${API}/settings/maintenance`);
        setMaintenanceEnabled(response.data.enabled || false);
      } catch (error) {
        console.error('Error checking maintenance:', error);
      }
    };
    checkMaintenance();
  }, [navigate]);

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-muted/30 px-6 py-12">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors mb-6">
            <ArrowLeft className="h-4 w-4" />
            Tornar a la botiga
          </Link>
          <h1 className="font-heading text-4xl font-medium text-foreground">
            Panell d'administració
          </h1>
          {maintenanceEnabled && (
            <div className="mt-4 bg-orange-100 border border-orange-400 rounded-xl px-4 py-3 flex items-center gap-2">
              <Wrench className="h-5 w-5 text-orange-600" />
              <span className="text-orange-800 font-medium">Mode manteniment actiu</span>
            </div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="space-y-4"
        >
          <Link to="/admin/products" data-testid="manage-products-link">
            <Button
              className="w-full h-20 text-xl font-semibold rounded-2xl flex items-center justify-center gap-3"
              size="lg"
            >
              <Package className="h-6 w-6" />
              Gestionar Productes
            </Button>
          </Link>

          <Link to="/admin/categories" data-testid="manage-categories-link">
            <Button
              className="w-full h-20 text-xl font-semibold rounded-2xl flex items-center justify-center gap-3"
              size="lg"
            >
              <Tag className="h-6 w-6" />
              Gestionar Categories
            </Button>
          </Link>

          <Link to="/admin/orders" data-testid="manage-orders-link">
            <Button
              className="w-full h-20 text-xl font-semibold rounded-2xl flex items-center justify-center gap-3"
              size="lg"
            >
              <ShoppingBag className="h-6 w-6" />
              Gestionar Comandes
            </Button>
          </Link>

          <Link to="/admin/hero-settings" data-testid="hero-settings-link">
            <Button
              className="w-full h-20 text-xl font-semibold rounded-2xl flex items-center justify-center gap-3"
              size="lg"
            >
              <Home className="h-6 w-6" />
              Configurar Pàgina Principal
            </Button>
          </Link>

          <Link to="/admin/maintenance" data-testid="maintenance-link">
            <Button
              className={`w-full h-20 text-xl font-semibold rounded-2xl flex items-center justify-center gap-3 ${
                maintenanceEnabled 
                  ? 'bg-orange-600 hover:bg-orange-700' 
                  : ''
              }`}
              size="lg"
            >
              <Wrench className="h-6 w-6" />
              Mode Manteniment
              {maintenanceEnabled && <span className="ml-2 text-sm bg-white/20 px-2 py-1 rounded">ACTIU</span>}
            </Button>
          </Link>

          <Link to="/admin/database" data-testid="database-link">
            <Button
              variant="outline"
              className="w-full h-20 text-xl font-semibold rounded-2xl flex items-center justify-center gap-3"
              size="lg"
            >
              <Database className="h-6 w-6" />
              Base de Dades
            </Button>
          </Link>

          <Link to="/admin/change-password" data-testid="change-password-link">
            <Button
              variant="outline"
              className="w-full h-20 text-xl font-semibold rounded-2xl flex items-center justify-center gap-3"
              size="lg"
            >
              <Key className="h-6 w-6" />
              Canviar Contrasenya
            </Button>
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default AdminDashboard;